module.exports = __webpack_public_path__ + "img/score_3.c16cf663.png";